import { useQuery } from '@tanstack/react-query';

import { electronApis } from '@/features/electron-api';
import { parseNotesFolders } from '@/features/local-mcp/apple-notes-setup';
import { inBrowser } from '@/utils/capabilities';

export function useNotesFoldersQuery(serverSlug: string) {
  return useQuery({
    queryKey: [
      'integration-configuration',
      'apple-notes',
      'folders',
      serverSlug,
    ],
    queryFn: async () => {
      const folders = parseNotesFolders(
        await electronApis.axonMcp.getNotesStats(serverSlug)
      );
      if (!folders) throw new Error('Unexpected get-notes-stats output');
      return folders;
    },
    // Counting notes runs AppleScript over every folder, so it isn't redone on focus
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !inBrowser(),
  });
}
